module.exports = __webpack_public_path__ + "img/img_22.d4d38ef7.png";